import moment from "moment";
// import SingleSelectComponent from "../../../components/single-select/single-select.component";
import MultiSelectComponent from "../../../components/multi-select/multi-select.component";
import { DATE_TYPE_CODES, formats } from "../../../config/constants";
import CodeMasterModel from "../../../models/common/code-master.model";
import loginModel from "../../../models/login.model";
import ReportModel from "../../../models/report/report-model.model";

import ViewBase from "../../view-base.view";

export default function FfCostReportView() {
  ViewBase.call(this);

  const DEFAULT_FILTERS = {
    periodCode: DATE_TYPE_CODES.MONTH,
    toDate: moment().format(formats.API_MONTH_FORMAT),
    fromDate: moment().subtract(1, 'month').format(formats.API_MONTH_FORMAT),
    country: [],
    bu: [],
    // business:[],
    ffType: [],
    ffContractType: []
  }

  const REPORT_FILTER_PARAMS = Object.freeze({
    dataSourceCode: '',
    periodCode: '',
    fromDate: '',
    toDate: '',
    xAxis: '',
    yAxis: '',
    zAxis: '',
    parameters: ''
  });

  let filters = structuredClone(DEFAULT_FILTERS);
  let currentFilter = {};
  // let iframeHeight = 300;
  const spacingHeight = 360;// 40 is the total height of margin/padding/scrollbar/header/search filter. Adjust accordingly if style changes. 
  let htmlRaw = '';
  let listBU = [];
  // let listBusiness = [];
  let listFFType = [];
  let listFFContractType = [];
  let listCountry = [];
  let periodTypes = [{ code: 'M', name: 'Month' }/*,{code:'Q',name:'Quarter'},{code:'Y',name:'Year'}*/];
  let isCalc =false;

  const dataSourceCode = 'FFCostHtml';//m.route.param().dataSourceCode;    

  const buildParams = (isRaw) => {
    const params = structuredClone(REPORT_FILTER_PARAMS);

    params.countryCode = loginModel.credentials.country;
    params.dataSourceCode = dataSourceCode;
    params.periodCode = filters.periodCode;
    params.fromDate = filters.fromDate;
    params.toDate = filters.toDate;
    params.parameters = stringifyFilterParams(isRaw);
    return params;
  }

  const stringifyFilterParams = (isRaw) => {
    let sParams = '';
    if (filters.bu.length > 0) sParams += '^^@FFBusinessBU:=' + filters.bu.join("^");
    // if (filters.business.length>0) sParams += '^^@FFBusiness:='+filters.business.join("^");
    if (filters.ffType.length > 0) sParams += '^^@FFTypeDashboard:=' + filters.ffType.join("^");
    if (filters.ffContractType.length > 0) sParams += '^^@FFContractType:=' + filters.ffContractType.join("^");
    if (filters.country.length > 0) sParams += '^^@Country:=' + filters.country.join("^");
    if (isRaw) sParams += '^^@IsRaw:=true';
    if (isCalc) sParams += '^^@IsCalc:=true';
    return sParams;
  }

  const renderDateInputLabel = () => {
    return periodTypes.find(x => x.code == filters.periodCode).name;
  }

  const DateInputComponentForMonth = () => {
    return {
      view: ({ attrs: { fromDateFilter, toDateFilter } }) => {
        return [
          m('.d-flex.position-relative',
            m('.position-relative',
              m('input#range.form-control[type="month"][required]', {
                name: fromDateFilter,
                // min: moment().add(getMinPeriod(), 'months').format(formats.MONTH_FORMAT),
                // max: moment().add(getMaxPeriod(), 'months').format(formats.MONTH_FORMAT),
                value: filters.fromDate
                  ? moment(filters.fromDate, formats.API_MONTH_FORMAT).format(formats.MONTH_FORMAT)
                  : null,
                onchange: (e) => {
                  let selectedDate = e.target.value
                    ? moment(e.target.value, formats.MONTH_FORMAT).format(formats.API_MONTH_FORMAT)
                    : null;
                  if (moment(selectedDate).isAfter(filters.toDate)) {
                    filters.toDate = null;
                  }
                  filters.fromDate = selectedDate;
                }
              }),
              m('.invalid-tooltip', this.getText('LT00000729', 'This field is required')),
            ),
            m('.px-2.my-auto', '~'),
            m('.position-relative',
              m('input#range2.form-control[type="month"][required]', {
                name: toDateFilter,
                // min: filters.fromDate
                //   ? moment(filters.fromDate, formats.API_MONTH_FORMAT).format(formats.MONTH_FORMAT)
                //   : moment().add(getMinPeriod(), 'months').format(formats.MONTH_FORMAT),
                // max: moment().add(getMaxPeriod(), 'months').format(formats.MONTH_FORMAT),
                value: filters.toDate
                  ? moment(filters.toDate, formats.API_MONTH_FORMAT).format(formats.MONTH_FORMAT)
                  : null,
                onchange: (e) => {
                  let selectedDate = e.target.value
                    ? moment(e.target.value, formats.MONTH_FORMAT).format(formats.API_MONTH_FORMAT)
                    : null;
                  filters.toDate = selectedDate;
                }
              }),
              m('.invalid-tooltip', this.getText('LT00000729', 'This field is required')),
            ),
          ),
        ]
      }
    }
  }

  const initializeReportPage = () => {
    filters = structuredClone(DEFAULT_FILTERS);
    setBUList();
    // setBusinessList();
    setFFTypeList();
    setFFContractTypeList();
    setCountryList();
  }

  const setBUList = () => {
    CodeMasterModel.searchByCategoryV2('FFBusinessBU')
      .then(_data => {
        listBU = _data;
      });
  }
  // const setBusinessList = () => {    
  //   CodeMasterModel.searchByCategoryV2('FFBusiness')
  //         .then(_data => {
  //           listBusiness = _data;
  //         });
  // }
  const setFFTypeList = () => {
    CodeMasterModel.searchByCategoryV2('FFType')
      .then(_data => {
        listFFType = _data;
      });
  }
  const setFFContractTypeList = () => {
    CodeMasterModel.searchByCategoryV2('FFContractType')
      .then(_data => {
        listFFContractType = _data;
      });
  }
  const setCountryList = () => {
    CodeMasterModel.searchByCategoryV2('Country')
      .then(_data => {
        listCountry = _data;
      });
  }

  const search = (_reportParameter) => {
    this.showLoading();
    ReportModel.getReportHtmlData(_reportParameter, 'V2')
      .then((result) => {
        htmlRaw = result || '';
      }).catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
  }

  const handleSearch = (e) => {
    if (!this.validateForm(e)) return false;

    currentFilter = structuredClone(filters);

    if (!e.target.checkValidity()) {
      showSiteSelectTooltip(!currentFilter.site);
      return;
    }

    search(buildParams(false));
  }

  const handleClearFilters = () => {
    filters = structuredClone(DEFAULT_FILTERS);
    htmlRaw = '';
  }


  const handleDownloadExcel = (e) => {
    e.preventDefault();
    this.showLoading();

    ReportModel.downloadReportDataHtml(buildParams(true), `ff_${dataSourceCode}_${filters.fromDate}-${filters.toDate}.xls`, 'V2')
      .catch((error) => { this.handleError(error) })
      .finally(() => { this.hideLoading() })
  }

  return {
    oninit: () => {
      //   getDataSourceCode();
      initializeReportPage();
    },
    onupdate: () => {
      // Re-initialize when nagivating to other report page
      isCalc = m.route.param().calc === 'calc';
    },
    view: () => {
      return [
        /* SEARCH */
        m('.d-flex.flex-column.align-items-end.gap-2.mb-3',
          m('a.btn.btn-primary[data-bs-toggle="collapse"][href="#search-section"][aria-controls="search-section"][aria-expanded="true"]',
            m('i.bi.bi-filter'),
            this.getText("LT00000232", "Filter"),
          ),
          m("#search-section.card.collapse.show.w-100",
            m(".card-body",
              m('form.needs-validation[novalidate]', { onsubmit: handleSearch },
                m('.row',
                  m('.col-md-8.col-xl-4.position-relative',
                    m('label.form-label.mandatory[for=range]',
                      renderDateInputLabel()
                    ),
                    m(DateInputComponentForMonth, { fromDateFilter: 'fromDate', toDateFilter: 'toDate' }),
                  ),
                  m('.col-md-4.col-xl-2.position-relative',
                    m('label.form-label', this.getText('LT00000188', 'Country')),
                    m(MultiSelectComponent, {
                      id: 'country',
                      items: listCountry,
                      selectedItems: filters.country,
                      keyOnly: true,
                      filterableByKey: true,
                      showKeyInLabel: true,
                      onSelect: (value) => {
                        filters.country = value;
                      }
                    }),
                  ),

                  m('.col-md-4.col-xl-2.position-relative',
                    m('label.form-label[for=bu]', this.getText('LT00000239', 'BU')),
                    m(MultiSelectComponent, {
                      id: "bu",
                      items: listBU,
                      selectedItems: filters.bu,
                      keyOnly: true,
                      filterableByKey: true,
                      showKeyInLabel: false,
                      onSelect: (value) => {
                        filters.bu = value;
                      }
                    }),
                  ),
                  m('.col-md-4.col-xl-2.position-relative',
                    m('label.form-label[for=ffType]', 'FF Type'),
                    m(MultiSelectComponent, {
                      id: 'ffType',
                      items: listFFType,
                      selectedItems: filters.ffType,
                      keyOnly: true,
                      filterableByKey: true,
                      showKeyInLabel: false,
                      onSelect: (value) => {
                        filters.ffType = value;
                      }
                    }),
                  ),
                  m('.col-md-4.col-xl-2.position-relative',
                    m('label.form-label[for=ffContractType]', 'FF Contract Type'),
                    m(MultiSelectComponent, {
                      id: 'ffContractType',
                      items: listFFContractType,
                      selectedItems: filters.ffContractType,
                      keyOnly: true,
                      filterableByKey: true,
                      showKeyInLabel: false,
                      onSelect: (value) => {
                        filters.ffContractType = value;
                      }
                    }),
                  ),
                  // Search & clear buttons
                  m('.col-12.d-flex.justify-content-end.gap-2.mt-2',
                    m('button.btn.btn-primary', this.getText("LT00000001", "Search")),
                    m('button.btn.btn-white[type=button]',
                      { onclick: handleClearFilters },
                      this.getText("LT00000031", "Clear")
                    ),
                  ),
                )
              )
            )
          ),
        ),

        /* TABLE */
        m('.card',
          m('.card-body',
            m('.d-flex.justify-content-end.mb-2',
              m('.input-group.w-auto',
                m('button.btn.btn-primary',
                  {
                    disabled: !htmlRaw,
                    onclick: handleDownloadExcel
                  },
                  m('i.bi.bi-file-earmark-arrow-down'),
                  this.getText('LT00000492', 'Download')
                ),
              ),
            ),
            m('.row.g-2',
              m('.col-12',
                htmlRaw ?
                  m('iframe', {
                    // onload: (e) => {
                    //   iframeHeight = e.target.contentWindow.document.body.scrollHeight + spacingHeight;
                    // },
                    id: 'preRenderedTable',
                    srcdoc: htmlRaw,
                    style: `width: 100%; height: calc(100vh - ${spacingHeight}px);`,
                  }) :
                  m("div",
                    { style: { 'text-align': "center" } },
                    this.getText("EM00000837", "Click search button to generate report.")
                  ),
              ),
            )
          )
        ),

        this.getBaseViews(),
      ];
    },
  };
}